<template>
<div class="page-content">
  <nav class="page-breadcrumb" id="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ breadcrumbA }}</li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ breadcrumbB }}
      </li>
    </ol>
  </nav>

  <div class="row">
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">Ajustes aprobados pendientes de resolución</h6>
          <p class="card-description">
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-warning">En espera</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-success">Resuelto</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-info">Auditado</span>
          </p>
          <hr />
        </div>
      </div>
    </div>
  </div>

  <lista-carga v-if="load"></lista-carga>

  <div class="row" v-else>
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-4 col-sm-12">
              <label class="mr-sm-2">Mes y año</label>
              <input type="month" class="form-control mb-2 mr-sm-2" id="mes_anio" v-model="mesAnioFiltro" />
            </div>
            <div class="col-md-4 col-sm-12">
              <label class="mr-sm-2 w-100">&nbsp;</label>
              <button
                class="btn btn-md btn-success w-100"
                id="buscar"
                type="button"
                :disabled="buscandoAjustes"
                @click.stop.prevent="buscarAjustesMes"
              >
                {{ buscandoAjustes ? 'Consultando...' : 'Consultar Ajustes' }}
              </button>
            </div>
            <div class="col-md-4 col-sm-12">
              <label class="mr-sm-2 w-100">&nbsp;</label>
              <button
                class="btn btn-md btn-secondary w-100"
                id="limpiar_filtro_mes"
                type="button"
                @click.stop.prevent="verTodosAjustes"
              >
                Ver todos
              </button>
            </div>
          </div>

          <div v-if="mensajeFiltro" class="alert mb-3" :class="mensajeFiltroTipo">
            {{ mensajeFiltro }}
          </div>

          <div class="table-responsive">
            <table
              id="ajustes_resolucion"
              class="table table-theme table-row v-middle"
              data-plugin="dataTable"
            >
              <colgroup>
                <col style="width: 95px" />
                <col style="width: 170px" />
                <col style="width: 95px" />
                <col style="width: 145px" />
                <col style="width: 150px" />
                <col style="width: 115px" />
                <col style="width: 150px" />
                <col style="width: 85px" />
                <col style="width: 190px" />
                <col style="width: 150px" />
                <col style="width: 90px" />
                <col style="width: 170px" />
                <col style="width: 145px" />
              </colgroup>

              <thead>
                <tr>
                  <th><span class="text-muted">Estado</span></th>
                  <th><span class="text-muted">Motivo</span></th>
                  <th><span class="text-muted">ID ajuste</span></th>
                  <th><span class="text-muted">Fecha carga</span></th>
                  <th><span class="text-muted">Regional</span></th>
                  <th><span class="text-muted">DNI Regional</span></th>
                  <th><span class="text-muted">Operación</span></th>
                  <th><span class="text-muted">Legajo</span></th>
                  <th><span class="text-muted">Empleado</span></th>
                  <th><span class="text-muted">Concepto</span></th>
                  <th><span class="text-muted">Cantidad</span></th>
                  <th><span class="text-muted">Detalle</span></th>
                  <th><span class="text-muted">Resuelto por</span></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="caso in ajustes" :key="caso.fireId">
                  <!-- 1 Estado resolución -->
                  <td class="text-sm text-wrap">
                    <span class="badge text-uppercase" :class="badgeResolucion(caso.status_resolucion)">
                      {{ caso.status_resolucion }}
                    </span>
                  </td>

                  <!-- 2 Motivo seleccionado -->
                  <td class="text-sm text-wrap">{{ caso.motivo_auditado || caso.motivo || '-' }}</td>

                  <!-- 3 ID ajuste -->
                  <td class="text-sm text-wrap">{{ caso.fireIdCorto }}</td>

                  <!-- 4 Fecha carga -->
                  <td class="text-sm text-wrap">{{ caso.fecha_carga }}</td>

                  <!-- 5 Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable }}</td>

                  <!-- 6 DNI Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable_dni }}</td>

                  <!-- 7 Operación -->
                  <td class="text-sm text-wrap">{{ caso.operacion_raiz }}</td>

                  <!-- 8 Legajo -->
                  <td class="text-sm text-wrap">{{ caso.legajo }}</td>

                  <!-- 9 Empleado -->
                  <td class="text-sm text-wrap">{{ caso.nombre }}</td>

                  <!-- 10 Concepto -->
                  <td class="text-sm text-wrap">{{ caso.novedad }}</td>

                  <!-- 11 Cantidad -->
                  <td class="text-sm text-wrap">{{ caso.cantidad }}</td>

                  <!-- 12 Detalle -->
                  <td class="text-sm text-wrap">
                    
                    <button class="btn btn-sm btn-info mt-1" @click="verDetalle(caso)">Ver detalle</button>
                  </td>

                  <!-- 13 Resuelto por -->
                  <td class="text-sm text-wrap">
                    <span v-if="caso.resolutor_nombre && caso.resolutor_nombre !== '-'">
                      {{ caso.resolutor_nombre }}<br />
                      <small>{{ caso.fecha_resolucion }}</small>
                    </span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();
require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
require("../../../public/assets/css/data-table-estilos-propios.css");

import firebase from "firebase/app";
import "firebase/database";

import ListaCarga from "../ListaCarga";
import moment from "moment";

const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
const userPermission = JSON.parse(sessionStorage.getItem("userPermisos") || "[]");

export default {
  name: "AjustesResolucionSector",
  components: { ListaCarga },
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Resolución de Ajustes Aprobados",
    descripcion: "Listado de ajustes aprobados por Génesis para resolver y cerrar",
    ajustes: [],
    load: true,
    moduloPermiso: "AjustesResolucion",
    mesAnioFiltro: "",
    filtroDesde: "",
    filtroHasta: "",
    mensajeFiltro: "",
    mensajeFiltroTipo: "alert-info",
    buscandoAjustes: false,
  }),
  methods: {
    isEditor(modulo) {
      if (userPermission.find(record => record.ModulosAccess === modulo)) {
        return userPermission.find(record => record.ModulosAccess === modulo).Editor;
      }
      return false;
    },

    addZero(i) {
      return i < 10 ? "0" + i : i;
    },

    timestampActual() {
      const h = new Date();
      const hora = this.addZero(h.getHours());
      const minutos = ("0" + h.getMinutes()).substr(-2);
      const segundos = ("0" + h.getSeconds()).substr(-2);

      const today = new Date();
      const m = today.getMonth() + 1;
      const mes = m < 10 ? "0" + m : m;
      let dia = today.getDate();
      dia = dia < 10 ? "0" + dia : dia;

      return today.getFullYear() + "-" + mes + "-" + dia + " " + hora + ":" + minutos + ":" + segundos;
    },

    usuarioNombre() {
      const nombre = `${userData.leg_nombre || ""} ${userData.leg_apellido || ""}`.trim();
      return nombre || userData.name || "Usuario Génesis";
    },

    usuarioDni() {
      return userData.leg_numdoc || userData.dni || "-";
    },

    usuarioLegajo() {
      return userData.leg_numero || userData.legajo || "-";
    },

    badgeResolucion(status) {
      if (status === "Resuelto") return "badge-success";
      return "badge-warning";
    },

    normalizarStatusResolucion(item) {
      if (item.status_resolucion) return item.status_resolucion;
      if (item.estado_resolucion === "resuelto" || item.cerrado === 1 || item.resuelto === true) return "Resuelto";
      return "En espera";
    },

    esRechazado(item) {
      const status = String(item.status || "").trim().toLowerCase();
      const estado = String(item.estado || "").trim().toLowerCase();
      const statusResolucion = String(item.status_resolucion || "").trim().toLowerCase();
      const estadoResolucion = String(item.estado_resolucion || "").trim().toLowerCase();

      return (
        status === "rechazado" ||
        estado === "rechazado" ||
        statusResolucion === "rechazado" ||
        estadoResolucion === "rechazado" ||
        item.rechazado === true ||
        item.rechazado === 1 ||
        String(item.rechazado || "").trim().toLowerCase() === "true"
      );
    },

    esAprobado(item) {
      const status = String(item.status || "").trim().toLowerCase();
      const estado = String(item.estado || "").trim().toLowerCase();
      const aprobado = status === "aprobado" || estado === "aprobado";

      // El rechazo se guarda como una decisión final separada y puede conservar
      // status/estado = Aprobado para mantener la auditoría original.
      // Capital Humano debe recibir únicamente aprobados que NO estén rechazados.
      return aprobado && !this.esRechazado(item);
    },

    normalizarAjuste(key, item) {
      const fechaCarga = item.fecha_carga || item.fecha || "-";
      const statusResolucion = this.normalizarStatusResolucion(item);

      return {
        fireId: key,
        fireIdCorto: key.substring(0, 8),
        fecha: item.fecha || fechaCarga,
        fecha_carga: fechaCarga,

        responsable: item.responsable || "-",
        responsable_id: item.responsable_id || "-",
        responsable_dni: item.responsable_dni || "-",

        operacion_id: item.operacion_id || "-",
        operacion_raiz: item.operacion_raiz || "-",

        legajo: item.legajo || "-",
        nombre: item.nombre || "-",

        id_novedad: item.id_novedad || item.bejerman_id || "-",
        bejerman_id: item.bejerman_id || item.id_novedad || "-",
        novedad: item.novedad || item.concepto || "-",
        concepto: item.concepto || item.novedad || "-",
        cantidad: item.cantidad || "-",
        detalle: item.detalle || "-",

        status: item.status || "Aprobado",
        estado: item.estado || "aprobado",

        auditor_nombre: item.auditor_nombre || "-",
        auditor_dni: item.auditor_dni || "-",
        auditor_legajo: item.auditor_legajo || "-",
        fecha_auditoria: item.fecha_auditoria || "-",
        observacion_auditoria: item.observacion_auditoria || "-",
        motivo_auditado: item.motivo_auditado || item["motivo auditado"] || item.motivoAuditado || item.motivo || item.motivo_ajuste || item.motivo_resolucion || "",
        motivo: item.motivo || item.motivo_auditado || item["motivo auditado"] || item.motivoAuditado || item.motivo_ajuste || item.motivo_resolucion || "",

        status_resolucion: statusResolucion,
        estado_resolucion: item.estado_resolucion || (statusResolucion === "Resuelto" ? "resuelto" : "en_espera"),
        cerrado: item.cerrado || (statusResolucion === "Resuelto" ? 1 : 0),
        resuelto: item.resuelto || (statusResolucion === "Resuelto"),
        resolutor_nombre: item.resolutor_nombre || "-",
        resolutor_dni: item.resolutor_dni || "-",
        resolutor_legajo: item.resolutor_legajo || "-",
        fecha_resolucion: item.fecha_resolucion || "-",
        observacion_resolucion: item.observacion_resolucion || "-",
      };
    },

    destruirDataTable() {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_resolucion")) {
        $("#ajustes_resolucion").DataTable().clear().destroy();
      }
    },

    calcularRangoMes(mesAnio) {
      const fechaMes = moment(mesAnio, "YYYY-MM", true);

      if (!fechaMes.isValid()) {
        return null;
      }

      return {
        desde: fechaMes.clone().startOf("month").format("YYYY-MM-DD"),
        hasta: fechaMes.clone().endOf("month").format("YYYY-MM-DD")
      };
    },

    parsearFechaAjuste(value) {
      const limpio = String(value || "").trim();
      if (!limpio || limpio === "-") return null;

      const formatos = [
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD HH:mm",
        "YYYY-MM-DD",
        "DD/MM/YYYY HH:mm:ss",
        "DD/MM/YYYY HH:mm",
        "DD/MM/YYYY",
        "DD-MM-YYYY HH:mm:ss",
        "DD-MM-YYYY HH:mm",
        "DD-MM-YYYY"
      ];

      let fecha = moment(limpio, formatos, true);
      if (fecha.isValid()) return fecha;

      const match = limpio.match(/(\d{4}-\d{2}-\d{2}|\d{2}\/\d{2}\/\d{4}|\d{2}-\d{2}-\d{4})/);
      if (!match) return null;

      fecha = moment(match[1], ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
      return fecha.isValid() ? fecha : null;
    },

    ajusteDentroDeRango(item, rango) {
      if (!rango) return true;

      const fecha = this.parsearFechaAjuste(item.fecha_carga || item.fecha);
      if (!fecha) return false;

      const desde = moment(rango.desde, "YYYY-MM-DD", true).startOf("day");
      const hasta = moment(rango.hasta, "YYYY-MM-DD", true).endOf("day");

      return fecha.valueOf() >= desde.valueOf() && fecha.valueOf() <= hasta.valueOf();
    },

    procesarAjustesSnapshot(snapshot, rango) {
      const data = [];

      snapshot.forEach((child) => {
        const item = child.val() || {};
        if (this.esAprobado(item) && this.ajusteDentroDeRango(item, rango)) {
          data.push(this.normalizarAjuste(child.key, item));
        }
      });

      data.sort((a, b) => {
        const fa = a.fecha_carga || "";
        const fb = b.fecha_carga || "";
        return fb.localeCompare(fa);
      });

      return data;
    },

    aplicarAjustesDesdeSnapshot(snapshot, rango) {
      this.ajustes = this.procesarAjustesSnapshot(snapshot, rango);
      this.load = false;

      this.$nextTick(() => {
        this.initDataTable();
      });
    },

    getAjustes(rango = null) {
      this.load = true;
      this.buscandoAjustes = true;
      this.ajustes = [];
      this.destruirDataTable();

      this.mensajeFiltroTipo = "alert-info";
      this.mensajeFiltro = rango
        ? `Consultando ajustes desde ${rango.desde} hasta ${rango.hasta}...`
        : "Consultando todos los ajustes...";

      const ref = firebase.database().ref("ajustes_novedades");
      const consulta = rango
        ? ref.orderByChild("fecha_carga").startAt(rango.desde).endAt(rango.hasta + " 23:59:59")
        : ref;

      return consulta.once("value")
        .then((snapshot) => {
          this.aplicarAjustesDesdeSnapshot(snapshot, rango);
          this.mensajeFiltroTipo = "alert-success";
          this.mensajeFiltro = rango
            ? `Consulta realizada: ${this.ajustes.length} ajuste(s) aprobado(s), sin rechazados, entre ${rango.desde} y ${rango.hasta}.`
            : `Consulta realizada: ${this.ajustes.length} ajuste(s) aprobado(s), sin rechazados.`;
        })
        .catch((error) => {
          if (rango) {
            console.warn("No se pudo consultar Firebase por rango. Se consulta el nodo completo y se filtra localmente.", error);
            this.mensajeFiltroTipo = "alert-warning";
            this.mensajeFiltro = "Firebase no aceptó la consulta por rango. Consultando nodo completo y filtrando localmente...";

            return ref.once("value")
              .then((snapshot) => {
                this.aplicarAjustesDesdeSnapshot(snapshot, rango);
                this.mensajeFiltroTipo = "alert-success";
                this.mensajeFiltro = `Consulta realizada: ${this.ajustes.length} ajuste(s) aprobado(s), sin rechazados, entre ${rango.desde} y ${rango.hasta}.`;
              })
              .catch((fallbackError) => {
                console.error("Error al obtener ajustes aprobados:", fallbackError);
                this.load = false;
                this.mensajeFiltroTipo = "alert-danger";
                this.mensajeFiltro = "No se pudo consultar Firebase.";
                Swal.fire(
                  "Error",
                  "Ocurrió un error al cargar los ajustes aprobados. Revise la conexión o Firebase.",
                  "error"
                );
              })
              .finally(() => {
                this.buscandoAjustes = false;
              });
          }

          console.error("Error al obtener ajustes aprobados:", error);
          this.load = false;
          this.mensajeFiltroTipo = "alert-danger";
          this.mensajeFiltro = "No se pudo consultar Firebase.";
          Swal.fire(
            "Error",
            "Ocurrió un error al cargar los ajustes aprobados. Revise la conexión o Firebase.",
            "error"
          );
        })
        .finally(() => {
          if (!rango || this.mensajeFiltroTipo !== "alert-warning") {
            this.buscandoAjustes = false;
          }
        });
    },

    buscarAjustesMes() {
      const mesAnio = this.mesAnioFiltro || $("#mes_anio").val();

      if (this.buscandoAjustes) return;

      if (!mesAnio) {
        this.mensajeFiltroTipo = "alert-warning";
        this.mensajeFiltro = "Seleccione mes y año para consultar.";
        Swal.fire("Atención", "Seleccione mes y año.", "warning");
        return;
      }

      const rango = this.calcularRangoMes(mesAnio);
      if (!rango) {
        this.mensajeFiltroTipo = "alert-warning";
        this.mensajeFiltro = "El mes y año seleccionado no es válido.";
        Swal.fire("Atención", "El mes y año seleccionado no es válido.", "warning");
        return;
      }

      this.filtroDesde = rango.desde;
      this.filtroHasta = rango.hasta;
      this.getAjustes(rango);
    },

    verTodosAjustes() {
      this.mesAnioFiltro = "";
      this.filtroDesde = "";
      this.filtroHasta = "";
      $("#mes_anio").val("");
      this.getAjustes();
    },

    initDataTable() {
      this.destruirDataTable();

      const table = $("#ajustes_resolucion").DataTable({
        language: {
          decimal: ",",
          thousands: ".",
          info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
          infoFiltered: "(filtrado de un total de _MAX_ registros)",
          loadingRecords: "Cargando...",
          lengthMenu: "Mostrar _MENU_ registros",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior"
          },
          processing: "Procesando...",
          search: "Buscar:",
          searchPlaceholder: "Término de búsqueda",
          zeroRecords: "No se encontraron resultados",
          emptyTable: "Ningún dato disponible en esta tabla",
          aria: {
            sortAscending: ": Activar para ordenar la columna de manera ascendente",
            sortDescending: ": Activar para ordenar la columna de manera descendente"
          },
        },
        scrollX: false,
        autoWidth: false,
        search: { regex: true },
        dom: "Bfrtip",
        responsive: false,
        nowrap: false,
        order: [[3, "desc"]],
        columns: [
          { width: "95px" },
          { width: "170px" },
          { width: "95px" },
          { width: "145px" },
          { width: "150px" },
          { width: "115px" },
          { width: "150px" },
          { width: "85px" },
          { width: "190px" },
          { width: "150px" },
          { width: "90px" },
          { width: "170px", orderable: false },
          { width: "145px" }
        ],
        columnDefs: [
          { targets: "_all", className: "ajuste-celda" }
        ],
        drawCallback: function() {
          if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_resolucion")) {
            $("#ajustes_resolucion").DataTable().columns.adjust();
          }
        },
        buttons: [
          "copy",
          "excel",
          "csv",
          {
            text: "En espera",
            className: "btn btn-warning",
            action: function() {
              table.columns(0).search("En espera").draw();
            }
          },
          {
            text: "Resuelto",
            className: "btn btn-success",
            action: function() {
              table.columns(0).search("Resuelto").draw();
            }
          },
          {
            text: "Todos",
            className: "btn btn-secondary",
            action: () => {
              this.verTodosAjustes();
            }
          }
        ]
      });
    },

    cambiarResolucion(event, caso) {
      const nuevoStatus = event.target.value;
      const statusAnterior = caso.status_resolucion;

      if (!nuevoStatus || nuevoStatus === statusAnterior) return;

      if (statusAnterior === "Resuelto") {
        event.target.value = statusAnterior;
        Swal.fire("Caso cerrado", "Este ajuste ya fue resuelto y no puede volver a modificarse.", "info");
        return;
      }

      if (nuevoStatus === "En espera") {
        event.target.value = statusAnterior;
        return;
      }

      if (nuevoStatus === "Resuelto") {
        Swal.fire({
          title: "¿Marcar ajuste como resuelto?",
          text: `Se cerrará definitivamente el ajuste de ${caso.nombre} por ${caso.novedad}.`,
          input: "textarea",
          inputPlaceholder: "Observación opcional de resolución",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Sí, resolver y cerrar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            this.resolverAjuste(caso, result.value ? result.value.trim() : "-");
          } else {
            event.target.value = statusAnterior;
          }
        });
      }
    },

    resolverAjuste(caso, observacion) {
      const timestamp = this.timestampActual();
      const resolutor = this.usuarioNombre();

      Swal.fire({
        title: "Actualizando...",
        text: "Por favor espere mientras se cierra el ajuste.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const updateData = {
        // Se mantiene la aprobación de Génesis. No se pisa status ni estado.
        status: "Aprobado",
        estado: "aprobado",

        status_resolucion: "Resuelto",
        estado_resolucion: "resuelto",
        cerrado: 1,
        resuelto: true,
        fecha_resolucion: timestamp,
        resolutor_nombre: resolutor,
        resolutor_dni: this.usuarioDni(),
        resolutor_legajo: this.usuarioLegajo(),
        observacion_resolucion: observacion || "-"
      };

      const historialData = {
        fecha: timestamp,
        accion: "Resolución de ajuste",
        status_auditoria: caso.status,
        estado_auditoria: caso.estado,
        status_resolucion_anterior: caso.status_resolucion,
        status_resolucion_nuevo: "Resuelto",
        estado_resolucion: "resuelto",
        observacion: observacion || "-",
        nombre: resolutor,
        dni: this.usuarioDni(),
        legajo: this.usuarioLegajo()
      };

      const ref = firebase.database().ref("ajustes_novedades/" + caso.fireId);

      ref.update(updateData)
        .then(() => ref.child("historial").push(historialData))
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Caso cerrado",
            text: "El ajuste quedó resuelto correctamente.",
            timer: 1800,
            showConfirmButton: false
          });
          this.getAjustes();
        })
        .catch((error) => {
          console.error("Error al resolver ajuste:", error);
          Swal.fire(
            "Error",
            "No se pudo resolver el ajuste. Revise la conexión e intente nuevamente.",
            "error"
          );
          this.getAjustes();
        });
    },

    escapeHtml(value) {
      return String(value || "-")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },

    resumenDetalle(detalle) {
      const value = String(detalle || "-").trim();
      if (!value || value === "-") return "-";
      return value.length > 45 ? value.substring(0, 45) + "..." : value;
    },

    verDetalle(caso) {
      Swal.fire({
        title: "Detalle del ajuste aprobado",
        width: 850,
        html: `
          <div style="text-align:left; font-size:14px;">
            <b>ID Firebase:</b> ${this.escapeHtml(caso.fireId)}<br>
            <b>Fecha carga:</b> ${this.escapeHtml(caso.fecha_carga)}<br>
            <b>Regional:</b> ${this.escapeHtml(caso.responsable)} (${this.escapeHtml(caso.responsable_dni)})<br>
            <b>Operación:</b> ${this.escapeHtml(caso.operacion_raiz)}<br>
            <hr>
            <b>Legajo:</b> ${this.escapeHtml(caso.legajo)}<br>
            <b>Empleado:</b> ${this.escapeHtml(caso.nombre)}<br>
            <b>Concepto:</b> ${this.escapeHtml(caso.novedad)}<br>
            <b>ID concepto / Bejerman:</b> ${this.escapeHtml(caso.bejerman_id)}<br>
            <b>Cantidad:</b> ${this.escapeHtml(caso.cantidad)}<br>
            <b>Detalle:</b><br>${this.escapeHtml(caso.detalle)}<br>
            <hr>
            <b>Auditoría Génesis:</b> ${this.escapeHtml(caso.status)}<br>
            <b>Auditado por:</b> ${this.escapeHtml(caso.auditor_nombre)}<br>
            <b>DNI auditor:</b> ${this.escapeHtml(caso.auditor_dni)}<br>
            <b>Fecha auditoría:</b> ${this.escapeHtml(caso.fecha_auditoria)}<br>
            <b>Observación auditoría:</b><br>${this.escapeHtml(caso.observacion_auditoria)}<br>
            <hr>
            <b>Estado resolución:</b> ${this.escapeHtml(caso.status_resolucion)}<br>
            <b>Motivo:</b> ${this.escapeHtml(caso.motivo_auditado || caso.motivo || "-")}<br>
            <b>Resuelto por:</b> ${this.escapeHtml(caso.resolutor_nombre)}<br>
            <b>DNI resolutor:</b> ${this.escapeHtml(caso.resolutor_dni)}<br>
            <b>Fecha resolución:</b> ${this.escapeHtml(caso.fecha_resolucion)}<br>
            <b>Observación resolución:</b><br>${this.escapeHtml(caso.observacion_resolucion)}
          </div>
        `,
        confirmButtonText: "Cerrar"
      });
    }
  },

  mounted() {
    this.getAjustes();
  }
};
</script>

<style type="text/css">
.imprimir {
  color: #212529 !important;
  background-color: #fbbc06 !important;
  border-color: #fbbc06 !important;
}

#ajustes_resolucion {
  width: 100% !important;
  table-layout: fixed !important;
}

#ajustes_resolucion th,
#ajustes_resolucion td {
  box-sizing: border-box;
  vertical-align: middle !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  padding: 8px 10px !important;
}

#ajustes_resolucion th span {
  display: block;
  line-height: 1.15;
}

#ajustes_resolucion .badge {
  white-space: nowrap;
}

#ajustes_resolucion .custom-select {
  min-width: 125px;
  max-width: 100%;
}

#ajustes_resolucion .btn {
  white-space: nowrap;
}

.table-responsive {
  overflow-x: auto;
}
</style>